// Assets --- Normal illustrations
import almostNaked from "../../Assets/Images/almost_naked.jpg"
import blaspheme from "../../Assets/Images/blaspheme.jpg"
import chuter from "../../Assets/Images/chuter.jpg"
import dosNu from "../../Assets/Images/dos_nu.jpg"
import eyepatch from "../../Assets/Images/eyepatch.jpg"
import geisha from "../../Assets/Images/geisha.jpg"
import venus from "../../Assets/Images/Venus.jpg"
import yeuxCoulent from "../../Assets/Images/les_yeux_coulent.jpg"
import regardBrulant from "../../Assets/Images/regard_brulant.jpg"
// Assets --- Normal illustrations imgCompressed
import almostNakedCompressed from "../../Assets/Images/imgCompressed/almost_naked.jpg"
import blasphemeCompressed from "../../Assets/Images/imgCompressed/blaspheme.jpg"
import chuterCompressed from "../../Assets/Images/imgCompressed/chuter.jpg"
import dosNuCompressed from "../../Assets/Images/imgCompressed/dos_nu.jpg"
import eyepatchCompressed from "../../Assets/Images/imgCompressed/eyepatch.jpg"
import geishaCompressed from "../../Assets/Images/imgCompressed/geisha.jpg"
import venusCompressed from "../../Assets/Images/imgCompressed/Venus.jpg"
import yeuxCoulentCompressed from "../../Assets/Images/imgCompressed/les_yeux_coulent.jpg"
import regardBrulantCompressed from "../../Assets/Images/imgCompressed/regard_brulant.jpg"
// Assets - MockUped Illustrations
import almostNakedMockUp from "../../Assets/Images/mockups/almostNaked.png"
import blasphemeMockUp from "../../Assets/Images/mockups/blaspheme.png"
import chuterMockUp from "../../Assets/Images/mockups/chuter.png"
import dosNuMockUp from "../../Assets/Images/mockups/dosNu.png"
import eyepatchMockUp from "../../Assets/Images/mockups/eyepatch.png"
import geishaMockUp from "../../Assets/Images/mockups/geisha.png"
import venusMockUp from "../../Assets/Images/mockups/venus.png"
import yeuxCoulentMockUp from "../../Assets/Images/mockups/yeuxCoulent.png"
import regardBrulantMockUp from "../../Assets/Images/mockups/regardBrulant.png"
// Assets --- MockUped illustrations Compressed
import almostNakedMockUpCompressed from "../../Assets/Images/mockupCompressed/almostNaked.png"
import blasphemeMockUpCompressed from "../../Assets/Images/mockupCompressed/blaspheme.png"
import chuterMockUpCompressed from "../../Assets/Images/mockupCompressed/chuter.png"
import dosNuMockUpCompressed from "../../Assets/Images/mockupCompressed/dosNu.png"
import eyepatchMockUpCompressed from "../../Assets/Images/mockupCompressed/eyepatch.png"
import geishaMockUpCompressed from "../../Assets/Images/mockupCompressed/geisha.png"
import venusMockUpCompressed from "../../Assets/Images/mockupCompressed/venus.png"
import yeuxCoulentMockUpCompressed from "../../Assets/Images/mockupCompressed/yeuxCoulent.png"
import regardBrulantMockUpCompressed from "../../Assets/Images/mockupCompressed/regardBrulant.png"

const price = 20;

export const illustrationsData = [{
    'id': 0,
    'title': "Blaspheme",
    'img': blaspheme,
    'mockUp': blasphemeMockUp,
    'compressedImg': blasphemeCompressed,
    'compressedMockUp': blasphemeMockUpCompressed,
    'price': price,

  },
  {
    'id': 1,
    'title': "Chuter",
    'img': chuter,
    'mockUp': chuterMockUp,
    'compressedImg': chuterCompressed,
    'compressedMockUp': chuterMockUpCompressed,
    'price': price,
    'paragraphHP': "Lorem 1"

  },
  {
    'id': 2,
    'title': "Dos Nu",
    'img': dosNu,
    'mockUp': dosNuMockUp,
    'compressedImg': dosNuCompressed,
    'compressedMockUp': dosNuMockUpCompressed,
    'price': price,
    'paragraphHP': "Lorem 2"
  },
  {
    'id': 3,
    'title': "Eyepatch",
    'img': eyepatch,
    'mockUp': eyepatchMockUp,
    'compressedImg': eyepatchCompressed,
    'compressedMockUp': eyepatchMockUpCompressed,
    'price': price,
    'paragraphHP': "Lorem 3"
  },
  {
    'id': 4,
    'title': "Almost Naked",
    'img': almostNaked,
    'mockUp': almostNakedMockUp,
    'compressedImg': almostNakedCompressed,
    'compressedMockUp': almostNakedMockUpCompressed,
    'price': price,

  },
  {
    'id': 5,
    'title': "Geisha",
    'img': geisha,
    'mockUp': geishaMockUp,
    'compressedImg': geishaCompressed,
    'compressedMockUp': geishaMockUpCompressed,
    'price': price,

  },
  {
    'id': 6,
    'title': "Pleurs",
    'img': yeuxCoulent,
    'mockUp': yeuxCoulentMockUp,
    'compressedImg': yeuxCoulentCompressed,
    'compressedMockUp': yeuxCoulentMockUpCompressed,
    'price': price,

  },
  {
    'id': 7,
    'title': "Regard Brulant",
    'img': regardBrulant,
    'mockUp': regardBrulantMockUp,
    'compressedImg': regardBrulantCompressed,
    'compressedMockUp': regardBrulantMockUpCompressed,
    'price': price,

  },
  {
    'id': 8,
    'title': "Venus",
    'img': venus,
    'mockUp': venusMockUp,
    'compressedImg': venusCompressed,
    'compressedMockUp': venusMockUpCompressed,
    'price': price,
  }
]